(() => {
  if (customElements.get('footer-usps')) return;

  class FooterUsps extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('.footer-usps__item')];
      this.index = 0;

      if (
        this.items.length < 2 ||
        this.dataset.autoslide !== 'true' ||
        window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ) return;

      this.interval = window.setInterval(() => {
        this.items[this.index].classList.remove('is-active');
        this.index = (this.index + 1) % this.items.length;
        this.items[this.index].classList.add('is-active');
      }, 2500);
    }

    disconnectedCallback() {
      window.clearInterval(this.interval);
    }
  }

  customElements.define('footer-usps', FooterUsps);
})();
